import { axios, deepSnakeCaseKeys } from 'shared';
import { ServicesRequest } from 'store/ServicesRequest/types';

export function createServicesRequest(servicesRequest: ServicesRequest) {
  return axios.post<ServicesRequest>('/v1/services_requests', { services_request: deepSnakeCaseKeys(servicesRequest) });
}
